<template>
    <head>
        <title>Offer Calculator</title>
    </head>

    <CalculatorLayout>
        <div class="bg-[#F7F9FC] border-b border-[#EBF1F9]">
            <div class="mx-auto pt-6 pb-6 w-[100%] sm:w-[90%] min-w-[290px] max-w-[1170px] flex items-center justify-between grid grid-cols-1 gap-6">
                <div class="pl-20 md:pl-48 lg:pl-16 lg:pr-16 lg:flex lg:flex-row lg:justify-between lg:space-x-1 flex-col space-y-1">
                    <div class="flex items-center space-x-1">
                        <img src="/img/icons/icon_blue_check_in_circle.svg" class="lg:w-6 w-5 lg:h-6 h-5" alt="Blue check icon" />
                        <p class="pl-2 xl:text-lg text-m text-[#2C2C4F]">{{ $t('offer_v1.Quote in') }} <strong>{{ $t('offer_v1.30 seconds') }}</strong></p>
                    </div>
                    <div class="flex items-center space-x-1">
                        <img src="/img/icons/icon_blue_check_in_circle.svg" class="lg:w-6 w-5 lg:h-6 h-5" alt="Blue check icon" />
                        <p class="pl-2 xl:text-lg text-m text-[#2C2C4F]"><strong>{{ $t('offer_v1.Free') }}</strong> {{ $t('offer_v1.technical inspection') }}</p>
                    </div>
                    <div class="flex items-center space-x-1">
                        <img src="/img/icons/icon_blue_check_in_circle.svg" class="lg:w-6 w-5 lg:h-6 h-5" alt="Blue check icon" />
                        <p class="pl-2 xl:text-lg text-m text-[#2C2C4F]"><strong>{{ $t('offer_v1.Installation') }}</strong> {{ $t('offer_v1.within 2-4 weeks') }}</p>
                    </div>
                </div>

                <div class="px-3 md:px-0">
                    <!-- Progress Bar Container -->
                    <div class="w-full bg-[#E3EAF4] h-1.5 rounded-full">
                        <!-- Filled Progress with Transition -->
                        <div class="bg-[#108FE5] h-1.5 rounded-full" style="width: 100%"></div>
                    </div>
                    <div class="text-sm mt-1">{{ $t('offer_v1.Step') }} 4/4</div>
                </div>
            </div>

            <div class="flex justify-center">
                <h2 class="text-[28px] md:text-[38px] font-bold">{{ $t('offer_v1.Your Quote is Ready') }}</h2>
            </div>

            <div class="container mx-auto p-4">
                <div class="flex flex-wrap justify-center -mx-2 text-[14px] md:text-[16px]">
                    <div v-for="offer in offers" class="w-full px-2 mb-4 2xl:w-1/3" :class="`md:w-`+ (offers.length > 2 ? '1/3' : '1/2')">
                        <single-offer :offer="offer" :allSolarPanels="allSolarPanels" :calculatorId="calculatorId"/>
                    </div>
                </div>
                <div class="flex flex-wrap justify-center -mx-2 text-[14px] md:text-[16px]">
                    <div class="w-full px-2 mb-4 2xl:w-1/3" :class="`md:w-`+ (offers.length > 2 ? '1/3' : '1/2')">
                        <div class="bg-white border border-[#E3EAF4] p-4 h-full rounded-[12px] font-[16px]">
                            <div class="text-[#2C2C4F] font-weight-bold text-[20px] p-3">{{ $t('offer_v1.Your system design') }}</div>

                            <div class="px-3">
                                {{ $t('offer_v1.system_design_text') }}
                            </div>

                            <div class="p-3">
                                <img src="/img/offers_calc/Your_system_design.png" :alt="$t('offer_v1.Your system design')">
                            </div>

                            <div class="p-3">
                                <button @click="scrollToTop" class="w-full bg-[#0676C2] text-white font-bold text-[18px] px-6 py-4 rounded-[12px] shadow">
                                    {{ $t('offer_v1.system_design_button') }}
                                    <span style="vertical-align: -2px;" class="ml-3 text-2xl font-light">&gt;</span>
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="flex flex-wrap justify-center -mx-2 text-[14px] md:text-[16px]">
                    <div class="w-full px-2 mb-4 2xl:w-1/3" :class="`md:w-`+ (offers.length > 2 ? '1/3' : '1/2')">
                        <div class="bg-white border border-[#E3EAF4] p-4 h-full rounded-[12px] font-[16px]">
                            <div class="text-[#2C2C4F] font-weight-bold text-[20px] p-3">
                                {{ $t('offer_v1.Discuss your estimate with our experts') }}
                            </div>

                            <div class="px-3 pb-3">
                                {{ $t('offer_v1.discuss_text') }}
                            </div>

                            <div class="pt-4 bg-[#E3EAF4]/[.3] rounded-[12px] p-6 flex flex-col items-center">
                                <div class="flex p-2">
                                    <div class="flex-none p-1">
                                        <img src="/img/offers_calc/expert.png" class="w-[65px] h-[65px]" alt="Expert image" />
                                    </div>
                                    <div class="flex-1 p-2">
                                        <span class="text-[16px] text-[#0787DD] font-semibold">Stefan Goessens</span><br>
                                        <span class="text-[14px] text-[#959BB5]">info@novasolar.be</span>
                                    </div>
                                </div>
                                <button @click="scrollToTop" class="w-full bg-[#0676C2] text-white font-bold text-[18px] px-6 py-4 rounded-[12px] shadow">
                                    {{ $t('offer_v1.discuss_button') }}
                                    <span style="vertical-align: -2px;" class="ml-3 text-2xl font-light">&gt;</span>
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </CalculatorLayout>
</template>

<script>
import CalculatorLayout from "@/Layouts/CalculatorLayout";
import SingleOffer from "../../Components/OfferCalculator/SingleOffer.vue";

export default {
    props: {
        locale: {
            type: String,
            default: 'pl',
        },
        calculatorId: {
            type: String,
            required: true,
        },
    },
    components: {
        SingleOffer,
        CalculatorLayout,
    },
    mounted() {
        axios.post(
            this.route("api.calculator-create-offers"),
            {
                calculator_id: this.calculatorId,
            }
        ).then((response) => {
            if (response.data.offers) {
                this.offers = response.data.offers;
                this.allSolarPanels = response.data.allSolarPanels;
            } else {
                console.error('Not offers');
            }
        });
    },
    data() {
        return {
            offers: [],
            allSolarPanels: [],
        };
    },
    methods: {
        scrollToTop() {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        },
    },
};
</script>

<style>

</style>
